import React from 'react';

const Footer: React.FC = () => {
    return (
        <footer style={{ backgroundColor: 'black', color: 'white' }}>
            {/* Your footer content goes here */}
        </footer>
    );
};

export default Footer;
